import AddDistributionConfigForm from 'components/distributionSetting/distributionConfig/AddDistributionConfigForm'
import CommonLayout from 'layouts/DashboardLayout'
import React from 'react'

const DistributionConfig = () => {
    return (
        <CommonLayout>
            <AddDistributionConfigForm />
        </CommonLayout>
    )
}

export default DistributionConfig
